import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LocationHeaderComponent } from '../../components/location-header/location-header.component';
import { OrdersComponent } from '../../components/orders/orders.component';
import { PageComponent } from '../../components/page/page.component';
import { ActivatedRoute } from '@angular/router';
import { RouteUtil } from 'src/app/general/util/route-util';
import { Util } from 'src/app/general/util/util';
import { OrdersModel } from '../../components/orders/orders-model';
import { BackendService } from '../../services/backend.service';
import { SessionService } from '../../services/session.service';
import { AuthenticationStatus } from '../../util/util';
import { LocationRefundedOrdersModel } from '../../components/orders/location-refunded-orders-model';
import { NavigationService } from '../../services/navigation.service';
import { ActionComponent } from 'src/app/general/components/action/action.component';

@Component({
  selector: 'app-location-refunded-orders-page',
  standalone: true,
  imports: [
    CommonModule,
    PageComponent,
    TranslateModule,
    LocationHeaderComponent,
    OrdersComponent,
    ActionComponent
  ],
  templateUrl: './location-refunded-orders-page.component.html',
  styleUrls: ['./location-refunded-orders-page.component.css']
})
export class LocationRefundedOrdersPageComponent {
  locationId: string;
  locationRefundedOrdersModel: OrdersModel;

  constructor(
      private sessionService: SessionService,
      private activatedRoute: ActivatedRoute,
      private backendService: BackendService,
      private navigationService: NavigationService) {
    this.locationId = '';
    this.locationRefundedOrdersModel = new LocationRefundedOrdersModel(this.locationId, this.backendService);
  }

  ngOnInit(): void {
    if (this.sessionService.enforceAuthentication()
        == AuthenticationStatus.USER_NOT_AUTHENTICATED_AND_REDIRECTED_TO_SIGNIN_PAGE) {
      return;
    }

    const pathParams = RouteUtil.getPathParams(this.activatedRoute);
    this.locationId = Util.safeString(pathParams.get('locationId'));
    this.locationRefundedOrdersModel = new LocationRefundedOrdersModel(this.locationId, this.backendService);
  }

  public goToLocationPage(): void {
    this.navigationService.goToLocationPage(this.locationId)
  }
}
